import { onContactUs } from '../util/api';
import { storableError } from '../util/errors';

// ================ Action types ================ //

export const SEND_CONTACT_MESSAGE_REQUEST = 'app/contactUs/SEND_CONTACT_MESSAGE_REQUEST';
export const SEND_CONTACT_MESSAGE_SUCCESS = 'app/contactUs/SEND_CONTACT_MESSAGE_SUCCESS';
export const SEND_CONTACT_MESSAGE_ERROR = 'app/contactUs/SEND_CONTACT_MESSAGE_ERROR';
export const RESET_CONTACT_FORM = 'app/contactUs/RESET_CONTACT_FORM';

// ================ Reducer ================ //

const initialState = {
  sendMessageInProgress: false,
  sendMessageError: null,
  messageSent: false,
};

export default function contactUsReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SEND_CONTACT_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        messageSent: false,
      };
    case SEND_CONTACT_MESSAGE_SUCCESS:
      return {
        ...state,
        sendMessageInProgress: false,
        messageSent: true,
      };
    case SEND_CONTACT_MESSAGE_ERROR:
      return {
        ...state,
        sendMessageInProgress: false,
        sendMessageError: payload,
      };
    case RESET_CONTACT_FORM:
      return initialState;
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const sendContactMessageRequest = () => ({ type: SEND_CONTACT_MESSAGE_REQUEST });
export const sendContactMessageSuccess = () => ({ type: SEND_CONTACT_MESSAGE_SUCCESS });
export const sendContactMessageError = error => ({
  type: SEND_CONTACT_MESSAGE_ERROR,
  payload: error,
  error: true,
});
export const resetContactForm = () => ({ type: RESET_CONTACT_FORM });

// ================ Thunks ================ //

export const sendContactMessage = params => (dispatch, getState, sdk) => {
  dispatch(sendContactMessageRequest());

  const { name, email, topic, message, captchaToken } = params;

  const language = window?.localStorage?.selectedLanguage || `nl`;
  return onContactUs({ name, email, topic, message, captchaToken,language })
    .then(response => {
      console.log(response, '&&& &&& => contactUs response');
      return response;
    })
    .then(() => {
      dispatch(sendContactMessageSuccess());
      return true;
    })
    .catch(e => {
      dispatch(sendContactMessageError(storableError(e)));
      throw e;
    });
};
